import { I18n } from '@aws-amplify/core';
import { message, notification } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@/services/api';
import { BaseContext } from '@/types';
import { QUERY_KEYS } from '@/utils/query-keys';

export type DeleteFilesResponse = {
	file_id: string;
};

export type DeleteFilesRequest = BaseContext & {
	file_ids?: string[];
};

async function deleteFiles(body: DeleteFilesRequest): Promise<DeleteFilesResponse[]> {
	const url = '/file/bulk-delete';
	const { data } = await Api.delete<DeleteFilesResponse[]>(url, { params: body });
	return data;
}

export const useBulkDeleteFiles = () => {
	const queryClient = useQueryClient();
	return useMutation((body: DeleteFilesRequest) => deleteFiles(body), {
		onError: (err: any) => {
			const typeError = err.response.data.details[0].split('" ');
			notification.error({
				message: I18n.get('Ops... something happened!'),
				description: I18n.get(typeError[1])
			});
		},
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_FILES_LIST]);
			message.success(I18n.get('Files deleted successfully'));
		}
	});
};
